import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  draftsCount: 0,
  openOrdersCount: 0,
  payLaterOrdersCount: 0,
  riderOrdersCount:0
};

const slice = createSlice({
  name: "orderAndDraftCount",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getOrderAndDraftCount(state, action) {
      state.isLoading = false;
      state.payLaterOrdersCount = action.payload.payLaterOrdersCount;
      state.draftsCount = action.payload.draftsCount
      state.openOrdersCount = action.payload.openOrdersCount
      state.riderOrdersCount = action.payload.riderOrdersCount
    },
    increasePayLaterOrdersCount(state) {
      state.payLaterOrdersCount =  state.payLaterOrdersCount + 1;
    },
    increaseDraftsCount(state) {
      state.draftsCount =  state.draftsCount + 1;
    },
    increaseOpenOrdersCount(state) {
      state.openOrdersCount = state.openOrdersCount + 1 ;
    },
    increaseRiderOrdersCount(state) {
      state.riderOrdersCount = state.riderOrdersCount + 1 ;
    },
    decreasePayLaterOrdersCount(state) {
      state.payLaterOrdersCount =  state.payLaterOrdersCount - 1;
    },
    decreaseDraftsCount(state) {
      state.draftsCount =  state.draftsCount - 1;
    },
    decreaseOpenOrdersCount(state) {
      state.openOrdersCount = state.openOrdersCount - 1 ;
    },
    decreaseriderOrdersCount(state) {
      state.riderOrdersCount = state.riderOrdersCount - 1 ;
    }
  },
});

export default slice.reducer;

export const { increasePayLaterOrdersCount, increaseDraftsCount, increaseOpenOrdersCount, increaseRiderOrdersCount, decreasePayLaterOrdersCount, decreaseDraftsCount,  decreaseOpenOrdersCount, decreaseriderOrdersCount } = slice.actions;

export function getOrderAndDraftCount(venueId, levelId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/posCart/getOrdersAndDraftCount?venueId=${venueId}&levelId=${levelId}`);
      dispatch(slice.actions.getOrderAndDraftCount(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

